import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import solicitation from './modules/solicitation'
import works from './modules/works'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    works,
    solicitation
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js